import { Button } from "@/components/ui/button";
import { Search, Zap, Eye } from "lucide-react";
import RadarAnimation from "./RadarAnimation";

interface HeroSectionProps {
  onWaitlistClick: () => void;
}

const HeroSection = ({ onWaitlistClick }: HeroSectionProps) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32 md:pt-24 px-4 sm:px-6">
      {/* Background glow */}
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-brand-violet/10 blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] rounded-full bg-brand-blue/8 blur-[100px]" />
      </div>

      <div className="container relative z-10 grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-6 animate-[fadeInUp_0.7s_ease-out_both]">
          <div className="inline-flex items-center gap-2 rounded-full border border-brand-violet/30 bg-brand-violet/10 px-4 py-1.5 text-sm text-brand-violet">
            <Zap className="h-3.5 w-3.5" aria-hidden="true" />
            Ad Intelligence for Healthcare Practices
          </div>

          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight">
            Your Competition,{" "}
            <span className="brand-gradient-text">Uncovered.</span>
          </h1>

          <p className="text-base sm:text-lg text-muted-foreground max-w-lg leading-relaxed">
            Stop guessing. See exactly what offers local practices are running to attract new patients - across Meta and Google.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button size="lg" className="gap-2 text-base font-semibold px-8" onClick={onWaitlistClick}>
              <Search className="h-4 w-4" aria-hidden="true" />
              Join the Waitlist
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="gap-2 text-base border-border hover:bg-secondary"
              onClick={() => document.getElementById("search")?.scrollIntoView({ behavior: "smooth" })}
            >
              <Eye className="h-4 w-4" aria-hidden="true" />
              See How It Works
            </Button>
          </div>

          <div className="flex flex-wrap items-center gap-3 sm:gap-6 pt-2 text-xs sm:text-sm text-muted-foreground">
            <span className="flex items-center gap-1.5">
              <span className="h-2 w-2 rounded-full bg-primary animate-pulse" aria-hidden="true" />
              Founder's Rate
            </span>
            <span className="font-semibold text-foreground">$47/mo forever</span>
            <span>for waitlist members</span>
          </div>
          <p className="text-xs text-muted-foreground/70">
            Joining the waitlist locks in your Founder's Rate of $47/mo forever.
          </p>
        </div>

        <div
          className="flex justify-center animate-[fadeInScale_0.8s_ease-out_0.3s_both]"
          aria-hidden="true"
        >
          {/* Fixed dimensions to prevent CLS */}
          <div className="lg:scale-100 scale-75 w-80 h-80">
            <RadarAnimation />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;